import { FC } from 'react'
import { Image } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import css from './index.module.less';
import { useSearchParams } from 'react-router-dom';

export const ImageShow: FC = () => {
  const { t } = useTranslation();
  // 使用 useSearchParams 获取 query 参数
  const [searchParams] = useSearchParams();
  const image = searchParams.get('image');
  const description = searchParams.get('description'); // 获取描述文本
  
  console.log(image , 'image from query params');
  return (
    <div className={css.PageImageShow}>
      <Image src={image || ''} />
      {description && (
        <div className={css.description}>
          {description}
        </div>
      )}
    </div>
  )
}

